import Image from "next/image";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import React, { PureComponent } from "react";

const USER_COUNT = gql`
  query {
    userCount {
      totalUsers
      newUsersLastMonth
    }
  }
`;
class StepFirstContent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
    };
  }

  render() {
    return (
      <>
        {" "}
        <Query query={USER_COUNT}>
          {({ data, error, loading }) => {
            console.log(data);
            if (loading) return <div className="general-loading" />;
            return (
              <div className="">
                <div className="signup__heading">Sign Up For Free</div>
                <div className="content__counter__section">
                  <div className="signup__image__section">
                    {" "}
                    <Image
                      src="/static/images/networkPic.svg"
                      alt="Find a co-founder today"
                      height={150}
                      width={150}
                      priority={true}
                    />
                  </div>
                  <div className="signup__content__section user__content__section">
                    <h3 className="userCount">
                      {data?.userCount?.newUsersLastMonth || 0}
                    </h3>
                    <p>
                      New users in the <br></br>last month.
                    </p>
                  </div>
                </div>
                <div className="content__counter__section">
                  <div className="signup__content__section network__content__section">
                    <p>Get access to our network of users!</p>

                    <h3 className="networkCount">
                      {data?.userCount?.totalUsers || 0}
                    </h3>
                  </div>
                  <div className="signup__image__section network__image__section">
                    {" "}
                    <Image
                      src="/static/images/newUser.svg"
                      alt="Find a co-founder today"
                      height={150}
                      width={150}
                      priority={true}
                    />
                  </div>
                </div>
                <div className="content__description__section">
                  <p>
                    Free accounts get 1 new conversation <span>daily.</span>
                  </p>
                  <p>
                    Come back each day to engage and propel your startup
                    journey!
                  </p>
                  <h4 className="upgrade__content">
                    Upgrade for unlimited messaging and other benefits!
                  </h4>
                </div>
              </div>
            );
          }}
        </Query>
      </>
    );
  }
}

export default StepFirstContent;
